// Static content pages — bilingual sections rendered by StaticPage.jsx
export const staticPages = {
    about: {
        eyebrow: { en: "The Family", te: "కుటుంబం" },
        title: {
            en: "Twenty-five summers,\none kitchen.",
            te: "ఇరవై ఐదు వేసవులు,\nఒకే వంటగది.",
        },
        intro: {
            en: "Bheema's Kumari Pickles began on a rooftop in Guntur in 2000, when Kumari Amma set the first tray of Avakaya out to sun-cure. A generation later, we're still the same kitchen — smaller than most restaurants, quieter than most factories, and unapologetically slow.",
            te: "2000లో గుంటూరు మేడపై కుమారి అమ్మ మొదటి ఆవకాయను ఎండలో ఉంచడంతో మా కథ మొదలైంది. ఒక తరం మారినా — ఇదే వంటగది, ఇదే చేతి రుచి.",
        },
        sections: [
            {
                h: { en: "The recipes", te: "వంటకాలు" },
                p: {
                    en: "Every one of our pickles comes from a handwritten notebook. No consultant, no food-scientist, no reverse-engineered supermarket flavour. If Kumari Amma's mother didn't make it, we don't sell it.",
                    te: "మా అన్ని ఊరగాయలు కుమారి అమ్మ నానమ్మ చేతిరాత నుండి వచ్చినవే. కన్సల్టెంట్ లేడు, ఫుడ్ సైంటిస్ట్ లేడు.",
                },
            },
            {
                h: { en: "The process", te: "తయారీ" },
                p: {
                    en: "Batches are small. Mangoes come from a co-operative of five farms outside Nuzvid. Oil comes from a single ghani in Guntur. Salt is rock salt, cured in Kutch. We ferment in ceramic, seal in leak-proof food-grade pouches, and label by hand.",
                    te: "చిన్న బ్యాచ్‌లు. నూజివీడు దగ్గర ఐదు రైతుల నుండి మామిడి. గుంటూరు ఘాణా నుండి నూనె. కుచ్ నుండి రాతి ఉప్పు.",
                },
            },
        ],
    },
    faq: {
        eyebrow: { en: "Small print", te: "చిన్న ప్రశ్నలు" },
        title: {
            en: "Everything you\nmight ask.",
            te: "మీ ప్రశ్నలు,\nమా జవాబులు.",
        },
        intro: {
            en: "If it's about ingredients, shipping, or storage — the answer is probably here. If not, WhatsApp us and Kumari Amma will reply herself.",
            te: "పదార్థాలు, డెలివరీ, నిల్వ గురించి ఏదైనా — ఇక్కడ దొరుకుతుంది.",
        },
        items: [
            {
                q: { en: "How long do your pickles last? Do they need refrigeration?", te: "మీ ఊరగాయలు ఎంతకాలం ఉంటాయి? ఫ్రిజ్ అవసరమా?" },
                a: {
                    en: "Veg & sweet pickles: 6–12 months unopened. Non-veg pickles must be refrigerated at all times. Once opened, refrigerate everything.",
                    te: "శాకాహార, తీపి: 6–12 నెలలు. మాంసాహారం: ఎల్లప్పుడూ ఫ్రిజ్. తెరిచిన తర్వాత అన్నీ ఫ్రిజ్‌లో.",
                },
            },
            {
                q: { en: "Are your pickles homemade / small-batch? What oil do you use?", te: "ఇంటి తయారీయేనా? ఏ నూనె వాడతారు?" },
                a: {
                    en: "Yes — every batch is under 40 pouches. We use cold-pressed groundnut oil from a single ghani in Guntur. Mustard pickles use cold-pressed mustard oil.",
                    te: "అవును. ప్రతి బ్యాచ్‌లో 40 ప్యాకెట్లకంటే తక్కువ. గుంటూరు ఘాణా ఘాణా నూనె.",
                },
            },
            {
                q: { en: "Do you use preservatives?", te: "కృత్రిమ పదార్థాలు వాడతారా?" },
                a: {
                    en: "None. Salt, chili, oil, and time are our only preservatives.",
                    te: "లేదు. ఉప్పు, మిర్చి, నూనె, సమయం — ఇవే మా సంరక్షకాలు.",
                },
            },
            {
                q: { en: "What's the difference between Mild, Medium, and Hot?", te: "తక్కువ / మధ్యస్థ / ఘాటు తేడా?" },
                a: {
                    en: "Mild uses Byadgi chili for colour. Medium adds Guntur chili. Hot means proper Guntur Sannam — bring water.",
                    te: "తక్కువ: బ్యాడగి మిర్చి. మధ్యస్థం: గుంటూరు. ఘాటు: పూర్తి గుంటూరు సన్నం.",
                },
            },
            {
                q: { en: "How is the pickle packed to prevent leakage during shipping?", te: "డెలివరీ లో లీక్ కాకుండా ఎలా?" },
                a: {
                    en: "Every pouch is a three-layer, food-grade, leak-proof pouch — heat-sealed, then bubble-wrapped inside a rigid corrugated box.",
                    te: "ప్రతి ప్యాకెట్ హీట్-షాప్ సీల్, రెండు బబుల్ ర్యాప్‌లు, గట్టి పెట్టెలో.",
                },
            },
            {
                q: { en: "Which areas do you deliver to, and how long does delivery take?", te: "ఎక్కడికి డెలివరీ? ఎన్ని రోజులు?" },
                a: {
                    en: "Pan-India: 3–7 working days. Andhra Pradesh & Telangana: 2–4 days. International orders are accepted — timelines and charges are confirmed on WhatsApp before dispatch.",
                    te: "భారతదేశ వ్యాప్తంగా: 3–7 రోజులు. ఏపీ, తెలంగాణ: 2–4 రోజులు. అంతర్జాతీయ ఆర్డర్‌లు స్వీకరిస్తాము — వివరాలు WhatsApp లో.",
                },
            },
            {
                q: { en: "Can I order in bulk for a wedding, festival, or corporate gift?", te: "పెళ్లికి / పండుగకి బల్క్ ఆర్డర్?" },
                a: {
                    en: "Yes. WhatsApp us with quantities and delivery dates — we do 50 pouches minimum for bulk with custom labels and gift-boxing.",
                    te: "అవును. కనీసం 50 ప్యాకెట్లు, కస్టమ్ ల్యాబెల్‌లతో. WhatsApp చేయండి.",
                },
            },
            {
                q: { en: "What if my pouch arrives damaged or leaked?", te: "డ్యామేజ్ / లీక్ అయితే?" },
                a: {
                    en: "WhatsApp us a photo within 24 hours of delivery. We'll ship a replacement free of charge — no return needed.",
                    te: "24 గంటల్లో WhatsApp లో ఫోటో పంపండి. ఉచితంగా మార్చిపంపుతాము.",
                },
            },
            {
                q: { en: "Can I customize spice level or oil quantity?", te: "ఘాటు / నూనె తక్కువెక్కువ చేయగలరా?" },
                a: {
                    en: "Yes — please call us on +91 91000 05390 for any customisations required on spice levels, or mention it in your WhatsApp message.",
                    te: "అవును — ఘాటు స్థాయిలో మార్పుల కోసం +91 91000 05390 కు కాల్ చేయండి, లేదా WhatsApp సందేశంలో చెప్పండి.",
                },
            },
            {
                q: { en: "How do I pay — WhatsApp order vs online payment, is it safe?", te: "చెల్లింపు ఎలా? సురక్షితమేనా?" },
                a: {
                    en: "Two ways, both prepaid: online via Razorpay (UPI/cards/netbanking — fully encrypted, PCI-DSS certified), or place the order on WhatsApp and we'll send you a secure payment link before dispatch.",
                    te: "రెండు మార్గాలు, రెండూ ముందస్తు చెల్లింపు: Razorpay (UPI/కార్డ్) లేదా WhatsApp ఆర్డర్ — మేము సురక్షిత పేమెంట్ లింక్ పంపుతాము.",
                },
            },
            {
                q: { en: "Do you offer combo packs or sampler packs for first-time buyers?", te: "మొదటి సారి కొంటే సాంపిల్?" },
                a: {
                    en: "Yes. Ask on WhatsApp for the 100g Sampler Trio (mango + gongura + sweet mango). ₹249 including shipping.",
                    te: "అవును. 100g సాంపిల్ మూడు (మామిడి + గోంగూర + తీపి మామిడి). ₹249.",
                },
            },
        ],
    },
    storage: {
        eyebrow: { en: "How to keep it", te: "ఎలా నిల్వ చేయాలి" },
        title: {
            en: "Small rules,\nlong shelf life.",
            te: "చిన్న నియమాలు,\nదీర్ఘకాలిక రుచి.",
        },
        intro: {
            en: "Homemade pickle is alive — treat it kindly and it will keep you for a year. Treat it carelessly and it may not last a month.",
            te: "ఇంటి ఊరగాయ సజీవం — జాగ్రత్తగా వాడితే ఏడాదిపాటు ఉంటుంది.",
        },
        sections: [
            {
                h: { en: "The dry-spoon rule", te: "పొడి చెంచా నియమం" },
                p: {
                    en: "Always use a clean, completely dry spoon. Water is the enemy — one drop can start fungal growth within days.",
                    te: "ఎల్లప్పుడూ పొడి, శుభ్రమైన చెంచా వాడండి. నీరు శత్రువు — ఒక్క చుక్క కూడా ఫంగస్ కు కారణం.",
                },
            },
            {
                h: { en: "Sun & shade", te: "ఎండ, నీడ" },
                p: {
                    en: "Store in a cool, dry place away from direct sunlight. Kitchen shelf is fine; near the stove is not.",
                    te: "సూర్యరశ్మి తగలని చల్లని పొడి చోట. వంటగది అల్మారా సరి, స్టవ్ దగ్గర వద్దు.",
                },
            },
            {
                h: { en: "Oil separation", te: "నూనె వేరుపడటం" },
                p: {
                    en: "Oil rising to the top is natural and desirable — it's the seal. Stir gently before serving.",
                    te: "పైన నూనె కనిపించడం సాధారణం — అదే సంరక్షణ. వాడేముందు కదిలించండి.",
                },
            },
            {
                h: { en: "After opening", te: "తెరిచిన తర్వాత" },
                p: {
                    en: "Veg pickles: 45 days. Non-veg: 21 days, refrigerated. Sweet preserves: 60 days. Always keep lid tight.",
                    te: "శాకాహారం: 45 రోజులు. మాంసాహారం: 21 రోజులు (ఫ్రిజ్). తీపి: 60 రోజులు.",
                },
            },
            {
                h: { en: "Allergen notes", te: "అలర్జీ హెచ్చరికలు" },
                p: {
                    en: "Most pickles contain mustard. Non-veg pickles contain fish, chicken, mutton or prawn. Check individual product ingredients.",
                    te: "చాలా ఊరగాయలలో ఆవాలు ఉన్నాయి. మాంసాహారంలో చేప, కోడి, మటన్, రొయ్యలు.",
                },
            },
        ],
    },
    shipping: {
        eyebrow: { en: "Delivery & Returns", te: "డెలివరీ, రిటర్న్స్" },
        title: {
            en: "Slow-made,\nfast-shipped.",
            te: "నెమ్మది తయారీ,\nత్వరిత డెలివరీ.",
        },
        intro: {
            en: "Because our pickles are made in small batches, orders ship within 3–5 days of confirmation. Once dispatched, delivery is quick.",
            te: "చిన్న బ్యాచ్‌ల వల్ల, ఆర్డర్ పంపడానికి 3–5 రోజులు. తర్వాత త్వరగా చేరుతుంది.",
        },
        sections: [
            {
                h: { en: "Zones & timelines", te: "డెలివరీ ప్రాంతాలు" },
                p: {
                    en: "Andhra Pradesh & Telangana: 2–4 working days from dispatch. Rest of India: 3–7 working days. International orders are accepted — WhatsApp us your country and ZIP/postal code and we'll confirm the timeline and charges before dispatch.",
                    te: "ఏపీ, తెలంగాణ: 2–4 రోజులు. మిగతా భారతదేశం: 3–7 రోజులు. అంతర్జాతీయ ఆర్డర్‌లు స్వీకరిస్తాము — మీ దేశం, పోస్టల్ కోడ్ WhatsApp లో పంపండి.",
                },
            },
            {
                h: { en: "Shipping charges", te: "డెలివరీ ఛార్జీలు" },
                p: {
                    en: "Delivery is free on orders of 1 kg or more delivered within Andhra Pradesh and Telangana only. For every other pincode, charges depend on your pincode — the exact amount is shown at checkout once you enter your delivery address. No hidden fuel surcharges. International shipping is quoted separately on WhatsApp.",
                    te: "ఆంధ్రప్రదేశ్, తెలంగాణలో 1 కేజీ లేదా అంతకంటే ఎక్కువ ఆర్డర్‌లకు మాత్రమే ఉచిత డెలివరీ. మిగతా పిన్‌కోడ్‌లకు ఛార్జీలు మీ పిన్‌కోడ్‌పై ఆధారపడతాయి — చెక్‌అవుట్‌లో కనిపిస్తుంది.",
                },
            },
            {
                h: { en: "250 g packs", te: "250 గ్రా. ప్యాకెట్లు" },
                p: {
                    en: "250 g packs are sold only to Andhra Pradesh and Telangana pincodes — the small pack does not survive long-haul transit well. For every other pincode, please choose a 500 g or 1 kg pack.",
                    te: "250 గ్రా. ప్యాకెట్లు ఆంధ్రప్రదేశ్, తెలంగాణ పిన్‌కోడ్‌లకు మాత్రమే. మిగతా చోట్లకు 500 గ్రా. లేదా 1 కేజీ ఎంచుకోండి.",
                },
            },
            {
                h: { en: "Payment", te: "చెల్లింపు" },
                p: {
                    en: "We currently accept prepaid orders for first-time customers — UPI, card, or netbanking via Razorpay. Cash on Delivery unlocks from your second order onward, with a partial advance payment.",
                    te: "మొదటిసారి కస్టమర్‌లకు ముందస్తు చెల్లింపు మాత్రమే — UPI, కార్డ్, నెట్‌బ్యాంకింగ్. రెండో ఆర్డర్ నుండి పార్షియల్ అడ్వాన్స్‌తో COD అందుబాటులో ఉంటుంది.",
                },
            },
            {
                h: { en: "Returns & replacements", te: "రిటర్న్ / రీప్లేస్‌మెంట్" },
                p: {
                    en: "Being a perishable product, we do not accept returns. However, damaged, leaked, or wrong items will be replaced free of charge — WhatsApp us a photo within 24 hours of delivery.",
                    te: "పాడైపోయేది కావడం వల్ల రిటర్న్ చేయము. కానీ డ్యామేజ్, లీక్, తప్పు వస్తువులకు ఉచితంగా మార్చిపంపుతాము — 24 గంటల్లో WhatsApp లో ఫోటో పంపండి.",
                },
            },
            {
                h: { en: "Refund policy", te: "రీఫండ్" },
                p: {
                    en: "For Razorpay-paid orders, refunds (in eligible cases) reach your account within 5–7 working days.",
                    te: "Razorpay ద్వారా చెల్లించిన ఆర్డర్‌లకు రీఫండ్ 5–7 రోజుల్లో.",
                },
            },
        ],
    },
    privacy: {
        eyebrow: { en: "Privacy", te: "గోప్యత" },
        title: { en: "What we keep,\nwhat we don't.", te: "మేము దాచుకునేది,\nదాచుకోనిది." },
        intro: {
            en: "We collect the minimum needed to send your pickles to you and let you re-order easily. Nothing else.",
            te: "ఊరగాయలు మీకు చేర్చడానికి, మీరు మళ్ళీ ఆర్డర్ చేయడానికి కావలసిన కనీస సమాచారం మాత్రమే.",
        },
        sections: [
            {
                h: { en: "What we collect", te: "ఏం సేకరిస్తాము" },
                p: {
                    en: "Name, phone, optional email, and delivery address. Nothing else on this site.",
                    te: "పేరు, ఫోన్, ఐచ్ఛిక ఇమెయిల్, డెలివరీ చిరునామా. అంతే.",
                },
            },
            {
                h: { en: "Payments", te: "చెల్లింపులు" },
                p: {
                    en: "Payment details are processed by Razorpay directly. We never see, store, or handle your card/UPI credentials.",
                    te: "చెల్లింపు వివరాలు Razorpay నిర్వహిస్తారు. మేము ఎప్పుడూ చూడము, దాచము.",
                },
            },
            {
                h: { en: "Who we share with", te: "ఎవరితో పంచుకుంటాము" },
                p: {
                    en: "Only our courier partners — and only the delivery address. We never sell or share data for marketing.",
                    te: "కేవలం మా కొరియర్ భాగస్వాములతో — డెలివరీ చిరునామా మాత్రమే. మార్కెటింగ్ కోసం ఎప్పుడూ పంచుకోము.",
                },
            },
            {
                h: { en: "Cookies", te: "కుకీలు" },
                p: {
                    en: "We use a single localStorage item to remember your language preference. No third-party tracking cookies.",
                    te: "మీ భాషను గుర్తుంచుకోవడానికి ఒక localStorage ఐటమ్ మాత్రమే. మూడో-పార్టీ ట్రాకింగ్ లేదు.",
                },
            },
            {
                h: { en: "Delete my data", te: "నా డేటా తొలగించండి" },
                p: {
                    en: "WhatsApp us and we will delete your account within 7 days.",
                    te: "WhatsApp లో అడగండి — 7 రోజుల్లో మీ ఖాతా తొలగిస్తాము.",
                },
            },
        ],
    },
    terms: {
        eyebrow: { en: "Terms", te: "నిబంధనలు" },
        title: { en: "The fine print,\nwith love.", te: "నియమాలు,\nప్రేమతో." },
        intro: {
            en: "Thank you for choosing Bheema's Kumari Pickles. A few gentle notes about how we work — kept short and friendly so you can get back to the good part (the pickle). If anything here needs a second read, our WhatsApp is always open.",
            te: "కుమారి పికిల్స్‌ను ఎంచుకున్నందుకు ధన్యవాదాలు. మా పని విధానం గురించి కొన్ని ప్రేమపూర్వక వివరణలు. ఏవైనా సందేహాలు ఉంటే WhatsApp లో అడగండి.",
        },
        sections: [
            {
                h: { en: "About our pouches", te: "మా ప్యాకెట్ల గురించి" },
                p: {
                    en: "Each batch is small and hand-poured, so no two pouches are ever quite the same. Colour, texture, and the amount of oil settling on top may vary a little from one order to the next — that is simply how homemade pickle behaves, and we think it is part of the charm.",
                    te: "మా బ్యాచ్‌లు చిన్నవి, చేతితో తయారు చేసినవి. అందుకే ప్రతి ప్యాకెట్ కొద్దిగా వేరుగా ఉండవచ్చు — ఇది ఇంటి తయారీ పికిల్ యొక్క సహజ లక్షణం.",
                },
            },
            {
                h: { en: "Pricing", te: "ధరలు" },
                p: {
                    en: "All prices are in Indian Rupees and are inclusive of GST. We may revise prices from time to time as the cost of mangoes, spices, and cold-pressed oil changes — the price you see at checkout is the price you pay.",
                    te: "ధరలు INR లో, GSTతో సహా. మామిడి, మసాలాలు, నూనె ధరలతో పాటు మేము ధరలను సవరించవచ్చు. చెక్అవుట్‌లో కనిపించే ధరే మీరు చెల్లిస్తారు.",
                },
            },
            {
                h: { en: "Order confirmation", te: "ఆర్డర్ నిర్ధారణ" },
                p: {
                    en: "When you place an order, we treat it as a lovely request. We confirm it once we've checked availability and the delivery route to your pincode. In the rare case we can't fulfil an order, we'll let you know on WhatsApp and refund promptly.",
                    te: "మీరు ఆర్డర్ ఇచ్చినప్పుడు, అది మా వైపుకు వచ్చిన ఆహ్వానం లాంటిది. అందుబాటు, డెలివరీ మార్గాన్ని పరిశీలించి నిర్ధారిస్తాము. ఏదైనా అసాధ్యమైతే WhatsApp లో తెలుపుతాము, వెంటనే రిఫండ్ ఇస్తాము.",
                },
            },
            {
                h: { en: "Delivery timelines", te: "డెలివరీ సమయం" },
                p: {
                    en: "Our timelines are honest estimates, not promises. Occasional delays because of monsoons, festivals, or courier hiccups are outside our control, but we'll always keep you updated and stay in touch until your pouch reaches you.",
                    te: "మా సమయం అంచనాలు నిజాయితీగా ఉంటాయి, అయితే హామీలు కావు. వర్షాలు, పండుగలు, కొరియర్ కారణంగా ఆలస్యం జరిగినా, మీ ప్యాకెట్ చేరే వరకు మేము మీతో సంప్రదింపులో ఉంటాము.",
                },
            },
            {
                h: { en: "Returns & replacements", te: "రిటర్న్‌లు · మార్పు" },
                p: {
                    en: "Because pickle is a perishable food, we're unable to offer returns for change of mind. If your pouch arrives damaged, leaked, or the wrong item — please WhatsApp us within 24 hours with a photo, and we'll replace it warmly and quickly. See our Shipping & Returns page for full details.",
                    te: "పికిల్ ఆహారం కావడం వల్ల మనసు మారితే రిటర్న్ లేదు. ప్యాకెట్ పగిలిపోతే, లీక్ అయితే, లేదా తప్పు వస్తువు వస్తే — 24 గంటల్లో ఫోటోతో WhatsApp చేయండి. మేము తక్షణమే మార్పిడి చేస్తాము.",
                },
            },
            {
                h: { en: "A few gentle reminders", te: "కొన్ని ప్రేమపూర్వక సూచనలు" },
                p: {
                    en: "Please store the pouches as advised on the label — this keeps the flavour honest and the shelf life true. Recipes and photography on this site belong to the Kumari family; kindly ask before reproducing them elsewhere.",
                    te: "లేబుల్‌పై సూచించిన విధంగా ప్యాకెట్లను భద్రపరచండి. మా వంటకాలు, ఛాయాచిత్రాలు కుమారి కుటుంబం సొంతం — ఇతర చోట్ల ఉపయోగించే ముందు దయచేసి అడగండి.",
                },
            },
        ],
    },
    contact_page: {
        eyebrow: { en: "Reach the kitchen", te: "వంటగదిని చేరుకోండి" },
        title: { en: "The door's\nalways open.", te: "వంటగది తలుపు\nఎప్పుడూ తెరిచే ఉంటుంది." },
        intro: {
            en: "Message or call us — Kumari Amma or her assistant reply personally. No chatbots, no ticket queues.",
            te: "WhatsApp లో సందేశం పంపండి — కుమారి Amma లేదా ఆమె కుమార్తె ప్రవల్లి స్వయంగా జవాబిస్తారు.",
        },
        sections: [
            { h: { en: "Bulk / gifting / festival orders", te: "బల్క్ / గిఫ్ట్ / పండుగ" }, p: { en: "For 50+ pouches with custom labels or gift-boxing, WhatsApp us with quantities and delivery dates. We provide invoicing for corporate orders.", te: "50+ ప్యాకెట్లకు, WhatsApp చేయండి. కార్పొరేట్ ఇన్‌వాయిస్ ఇస్తాము." } },
            { h: { en: "Wholesale", te: "హోల్‌సేల్" }, p: { en: "Retailers stocking small-batch specialty foods — please email with your storefront details.", te: "చిన్న-బ్యాచ్ ప్రత్యేక దుకాణాలు — మీ దుకాణ వివరాలు ఇమెయిల్ చేయండి." } },
            { h: { en: "Press & partnerships", te: "మీడియా / భాగస్వామ్యం" }, p: { en: "Journalists, food writers, chefs — we love talking about pickle. Email us.", te: "మీడియా, ఫుడ్ రైటర్లు, చెఫ్‌లు — మేము మాట్లాడతాము." } },
        ],
    },
};

export const staticPageSlugs = Object.keys(staticPages);
